import { render, staticRenderFns } from "./YzSearchBtn.vue?vue&type=template&id=acf580d2&scoped=true&lang=pug&"
import script from "./YzSearchBtn.vue?vue&type=script&lang=js&"
export * from "./YzSearchBtn.vue?vue&type=script&lang=js&"
import style0 from "./YzSearchBtn.vue?vue&type=style&index=0&id=acf580d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acf580d2",
  null
  
)

export default component.exports